export * from './axios';
export * from './chatbotApi';
export * from './newsApi';
export * from './queries';
export * from './uploadSystem';
export * from './seller-queries';
export * from './order-queries';
export * from './survey-queries';

export const CPLAT_API_ROUTES = {
  //대시보드
  getHomeSummary: '/summary/get_home_summary',
  getPopupInfo: '/app/get_popup_info',
  getMarketModel: '/service/get_market_model',
  //마켓 순서 변경
  setMarketStoreSequence: '/user/set_market_store_sequence',
  getUserInfo: '/user/get_user_info',
  //알람 리스트 확인
  getNotificationBox: 'user/get_notification_box',
  getHomeOrderSummary: '/summary/get_home_order_summary',
  getRegisteredMarketInfo: '/user/get_registered_market_account_info',
  getRegisteredMarketAccountStore: 'user/get_registered_market_account_store',
  sendAuthCode: '/user/send_authentication_code',
  verifyAuthCode: '/user/verify_authentication_code',
  signUpByPhoneNo: '/user/sign_up_by_phone_no',
  signInByPhoneNo: '/user/sign_in_by_phone_no',
  registerMarketAccount: '/user/register_market_account',
  unregisterMarket: '/user/unregister_market_account',
  updateMarketAlias: '/user/update_market_store_alias',
  signout: '/user/update_push_alert_token',
  unsubscribe: '/user/unsubscribe',
  signinByPass: '/user/sign_in_by_pass', // 토큰 유효성 검사 및 유저 데이터 획득
  getUserInfoForDevSide: '/service/get_user_info_for_dev_side', // dev용 유저 리스트 가져오기
  hasStoreName: '/user/has_store_name', // 닉네임 중복체크 200 or 614
  setUserInfo: '/user/set_user_info', // 유저 정보 수정
  uploadImage: '/file/upload_image', // 이미지 업로드 흠..
  tempSignIn: '/user/valid_temp_auth_code_for_login', // app 에서 4자리 코드 로그인
  inquiry: '/user/set_ask_info',
  getInquiry: '/user/get_ask_info', // 질문 내역 가져오기
  setAuthCodeByMarket: '/user/set_authentication_code_by_market', // 2차 인증 완료 + 연동 완료
  // 주문처리
  getStoreList: '/order/get_store_list', // 발송처리 가능한 스토어 중 연동된 마켓 리스트
  getOrderList: '/order/get_order_list', // getStoreList로 조회한 마켓의 주문 리스트
  getOrderChangeList: '/order/get_order_change_list', // getStoreList로 조회한 마켓의 주문 리스트
  confirmOrder: '/order/confirm_order', // 주문확인
  setInvoice: '/order/set_invoice', // 발송처리
  confirmCancellation: '/order/confirm_cancellation', // 취소승인
  declineCancellation: '/order/decline_cancellation', // 취소거절(강제발송)
  cancelBySeller: '/order/cancel_by_seller', // 셀러에 의한 주문취소
  getShippingCompanyList: '/user/get_shipping_company_list', // 택배사 및 즐겨찾기 여부 조회
  setShippingCompanyList: '/user/set_shipping_company_list', // 택배사 즐겨찾기 설정
  // 문의
  setInquiryCommentTemplate: '/user/set_inquiry_comment_template', // 문의 템플릿 추가/수정/삭제
  getInquiryCommentTemplate: '/user/get_inquiry_comment_template', // 문의 템플릿 조회
  deleteInquiryCommentTemplate: '/user/delete_inquiry_comment_template', // 문의 템플릿 삭제
  updateMarketData: '/user/update_market_data', // 주문 수동 수집
  getInquiryList: '/inquiry/get_inquiry_list', // 문의 목록 조회
  getInquiryDetail: '/inquiry/get_inquiry_detail', // 문의 상세 조회
  generateAIRecommendedAnswer: '/inquiry/generate_ai_recommended_answer', // ai 답변 생성
  registerInquiryComment: '/inquiry/register_inquiry_comment', // 문의 답변 등록
  // 발견
  getBlogPosting: '/discovery/get_blog_posting', // 블로그 목록 조회
  // 통계
  getCalendar: '/sales/get_calendar', // 캘린더 조회
  getCalendarDaily: '/sales/get_calendar_daily', // 캘린더 상세 조회
  getPeriodReport: '/sales/get_period_report', // 최근 6개월 판매 통계 조회
  getPeriodDetail: '/sales/get_period_detail', // 월별 상세 통계 조회
  setEmailAddress: '/user/set_email_address', // 이메일 주소 저장
  // 사용자 행동 추적
  setUsageHistory: '/service/set_usage_history',

  getReviewSummary: 'buyer/get_review_summary',
  getReviewDetail: 'buyer/get_review_detail',

  // 리뷰 답변
  setReviewComment: 'buyer/set_review_comment',
  //AI 답변 추천
  getReviewCommentRecommendation: '/buyer/get_review_comment_recommendation',

  // AI 답변 추천 템플릿
  getReviewCommentTemplate: '/user/get_review_comment_template',
  setReviewCommentTemplate: '/user/set_review_comment_template',
  deleteReviewCommentTemplate: '/user/delete_review_comment_template',

  getUserMonitoringGoods: 'sellkey/get_user_monitoring_goods',
  setUserMonitoringGoods: 'sellkey/set_user_monitoring_goods',
  // 크롬 확장프로그램 저장 추천 키워드 조회
  getUserMonitoringGoodsRecommendedKeywords: 'sellkey/get_user_monitoring_goods_recommended_keywords',
  // 상점 주소로 검색하기
  searchGoodsWithStoreUrl: 'sellkey/analyze_store',

  paymentReadyForKakaoPay: '/user/payment_ready_for_kakao_pay',

  //셀러박스 구독모델 조회
  getSubscriptionModel: 'app/get_subscription_model',
  setSubscriptionForKakaopay: '/user/set_subscription_for_kakao_pay',

  //카드 결제 준비
  setSubscription: '/user/set_subscription',

  //멤버십 해지
  setUnscription: '/user/set_unsubscription',
  getPaymentInfo: '/user/get_payment_info', // 결제내역 가져오기
  getSubscriptionInfo: '/user/get_subscription_info', // 구독 정보

  // 로그인
  sendAuthenticationCode: '/auth/send_authentication_code',
  verifyAuthenticationCode: '/auth/verify_authentication_code',
  verifyEmail: '/auth/check_registration_by_email',
  signinByPhone: '/auth/sign_in',
  signinByEmail: '/auth/sign_in_by_email',
  signup: '/auth/sign_up',
  checkPhone: '/auth/check_registration_by_phone',

  // 판매자 계정
  updateAccount: '/seller/update_account',
  getInfo: '/seller/get_info',
  updateInfo: '/seller/update_info',
  getStores: '/seller/get_stores',

  // 대시보드
  getSummary: '/dashboard/get_summary',
  getOrderStatusSummary: '/dashboard/get_order_status_summary',
  getNewsBriefing: '/dashboard/get_news_briefing',
  getActivitySummary: '/dashboard/get_activity_summary',

  // 주문
  syncOrders: '/order/sync_orders',

  getOrderMarketStoreList: '/order/get_order_market_store_list',

  // 마켓 연동
  setNaverCommerceToken: '/user/set_naver_commerce_token',
  setImwebAuthorizationCode: '/user/set_imweb_authorization_code',
  setShopbyAuthorizationCode: '/user/set_shopby_authorization_code',
  setCafe24AuthorizationCode: '/user/set_cafe24_authorization_code',
};
